import {AccessGroup} from './accessGroup';
import {Apartment} from './apartment';
import {Building} from './building';
import {Room} from './room';
import {User} from './user';
/**
 *
 * @export
 * @interface Tenant
 */
export interface Tenant {
  /**
   *
   * @type {Array<string>}
   * @memberof Tenant
   */
  accessGroupIds?: Array<string>;
  /**
   *
   * @type {Array<AccessGroup>}
   * @memberof Tenant
   */
  accessGroups?: Array<AccessGroup>;
  /**
   *
   * @type {Apartment}
   * @memberof Tenant
   */
  apartment?: Apartment;
  /**
   *
   * @type {Building}
   * @memberof Tenant
   */
  building?: Building;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  leaseEnd?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  leaseStart?: string;
  /**
   *
   * @type {Room}
   * @memberof Tenant
   */
  room?: Room;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  roomId?: string;
  /**
   * - 创建: created - 激活: enabled - 禁用: disabled - 待激活: pending
   * @type {string}
   * @memberof Tenant
   */
  status?: TenantStatusEnum;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  updatedAt?: string;
  /**
   *
   * @type {User}
   * @memberof Tenant
   */
  user?: User;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  mobile?: string;
  /**
   * Phone extension (digits only, optional)
   * @type {string}
   * @memberof Tenant
   */
  phoneExt?: string | null;
}

export const TenantStatusEnum = {
  Created: 'Created',
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Pending: 'Pending',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TenantStatusEnum = (typeof TenantStatusEnum)[keyof typeof TenantStatusEnum];

/**
 *
 * @export
 * @interface TenantSendInviteReq
 */
export interface TenantSendInviteReq {
  /**
   * 所有未邀请的
   * @type {boolean}
   * @memberof TenantSendInviteReq
   */
  all?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof TenantSendInviteReq
   */
  ids: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TenantSendInviteReq
   */
  orgId?: string;
}
/**
 *
 * @export
 * @interface TenantSendInviteRsp
 */
export interface TenantSendInviteRsp {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof TenantSendInviteRsp
   */
  data?: {[key: string]: string};
}
/**
 *
 * @export
 * @interface TenantUpdateReq
 */
export interface TenantUpdateReq {
  /**
   *
   * @type {string}
   * @memberof TenantUpdateReq
   */
  id: string;
  /**
   *
   * @type {Tenant}
   * @memberof TenantUpdateReq
   */
  tenant: Tenant;
}
/**
 *
 * @export
 * @interface Tenants
 */
export interface Tenants {
  /**
   *
   * @type {Array<Tenant>}
   * @memberof Tenants
   */
  tenants?: Array<Tenant>;
  /**
   *
   * @type {number}
   * @memberof Tenants
   */
  total?: number;
}
/**
 *
 * @export
 * @interface SendInviteCallbackReq
 */
export interface SendInviteCallbackReq {
  /**
   * 邮箱
   * @type {string}
   * @memberof SendInviteCallbackReq
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof SendInviteCallbackReq
   */
  id?: string;
  /**
   * 验证码
   * @type {string}
   * @memberof SendInviteCallbackReq
   */
  verifyCode: string;
}
/**
 * 租户数据
 * @export
 * @interface SendInviteReqTenantUserData
 */
export interface SendInviteReqTenantUserData {
  /**
   * 房号
   * @type {string}
   * @memberof SendInviteReqTenantUserData
   */
  unitNum?: string;
}

// 批量导入单条成功项
export interface TenantBulkImportSuccessItem {
  id: string;
  email: string;
  name: string;
  unit: string;
  floor: string;
}

// 批量导入单条失败项
export interface TenantBulkImportErrorItem {
  row: number;
  message: string;
  data: Record<string, any>;
}

// 批量导入返回结构
export interface TenantBulkImportResult {
  success: boolean;
  message: string;
  results: {
    success: TenantBulkImportSuccessItem[];
    errors: TenantBulkImportErrorItem[];
    totalProcessed: number;
  };
}

// Update single tenant call method request
export interface TenantUpdateCallMethodReq {
  callMethod: 'MOBILE_APP' | 'SIP_PHONE';
}

// Update single tenant call method response
export interface TenantUpdateCallMethodRsp {
  success: boolean;
  tenantId: string;
  userId: string;
  callMethod: 'MOBILE_APP' | 'SIP_PHONE';
}

// Batch update tenant call method request
export interface TenantBatchUpdateCallMethodReq {
  tenantIds: string[];
  callMethod: 'MOBILE_APP' | 'SIP_PHONE';
}

// Batch update tenant call method response
export interface TenantBatchUpdateCallMethodRsp {
  success: boolean;
  updated: number;
  failed: number;
  results: Array<{
    success: boolean;
    tenantId: string;
    userId: string;
    callMethod: string;
  }>;
  errors: Array<{
    tenantId: string;
    error: string;
  }>;
}
